export class ContactUsViewModel {
    callUs: string;
    messageUs: string;
    findUs: string;
  }
